import React, { useMemo, forwardRef, useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Source({ isOpen, sentence, onSource }) {

    const findString = useCallback((array, searchString) => {
       // Normalize the search string
      const normalizedSearchString = searchString.toLowerCase().replace(/\s+/g, ' ').trim();
      const regex = new RegExp(`${normalizedSearchString}`, 'gm');
      return array.findIndex(element => {
          const normalizedElement = element.toLowerCase().replace(/\s+/g, ' ').trim()
          return normalizedElement.match(regex);
      });
    }, []);

    const para = useMemo(() => {
        const content = localStorage.getItem('content');
        const paras = [];
        if (content) {
            const parse = new DOMParser().parseFromString(content, 'text/html');
            parse.body.childNodes.forEach((node) => {
              node.innerText !== "" && paras.push(node.innerText.replace(/\s+/g, ' ').trim());
            })
            const regex = new RegExp(`${sentence}`, 'gm');
            let originalSentence = findString(paras, sentence);
            originalSentence = originalSentence !== -1 ? paras[originalSentence].replace(regex, `<mark>${sentence}</mark>`) : 'No Source Available';
            return originalSentence;
        }
    }, [sentence, findString]);

  const handleModalClose = () => {
    onSource({
        isOpen: false,
        sentence: ''
    });
  };

  return (
      <Dialog
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleModalClose}
        aria-describedby="alert-dialog-slide-description"
      >
      <div className="flex justify-end p-[0px]">
        <Tooltip
          title="Close"
          arrow
          placement="top"
          TransitionComponent={Zoom}
          TransitionProps={{ timeout: 300 }}
        >
          <button
            className="text-[#6c757d] text-lg hover:bg-[#edeeef] px-2 rounded-full"
            onClick={handleModalClose}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </Tooltip>
      </div>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
             <p dangerouslySetInnerHTML={{__html: para }} />
          </DialogContentText>
        </DialogContent>
      </Dialog>
  );
}

export default React.memo(Source);